var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{style:({ color: _vm.isPlay ? 'red' : '#05a6e5' }),attrs:{"type":"text","size":"small"},on:{"click":_vm.autoPlay}},[_vm._v(_vm._s(_vm.isPlay ? "暂停" : "播放"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }